<template>
  <div v-if="statistics == null" class="hb-abroad-index-page">
    <el-skeleton />
  </div>
  <div v-else class="hb-abroad-index-page">
    <hb_info_section_template title="共享邮箱" hideRightArrow="true">
      <template slot="content">
        <div>
          <el-link
            v-if="user_bind_info.bind_status == 1"
            type="primary"
            @click="showEmail"
            >{{ user_bind_info.email }}</el-link
          >
          <el-link v-else type="danger" @click="bindEmail">点击绑定</el-link>
        </div>
      </template>
    </hb_info_section_template>

    <hb_info_section_template title="申请信息" hideRightArrow="true">
      <template slot="content">
        <el-descriptions :column="4">
          <el-descriptions-item label="预计入学时间">{{
            user_bind_info.enrol_school_time
          }}</el-descriptions-item>
          <el-descriptions-item label="申请学位">{{
            user_bind_info.apply_academic_degree
          }}</el-descriptions-item>
          <el-descriptions-item label="申请国家(地区)">{{
            user_bind_info.apply_country
          }}</el-descriptions-item>
          <el-descriptions-item label="申请方向">
            {{ user_bind_info.apply_direction }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </hb_info_section_template>


    <hb_info_section_template
      title="个人信息"
      @headerClick="changeTab('three')"
    >
      <template slot="content">
        <div @click="changeTab('three')">
          <span class="desc-txt" v-if="statistics.userInformationData.status == 4"
            >已完成必填项</span
          >
          <span class="uncomplete" v-else-if="statistics.userInformationData.status == 5"
            >未完成必填项</span
          >
          <span class="uncomplete" v-else
            >未填写</span
          >
        </div>
      </template>
    </hb_info_section_template>

    <hb_info_section_template title="申请材料" @headerClick="changeTab('four')">
      <template slot="content">
        <el-descriptions :column="4">
<!--          <el-descriptions-item label="已确认">-->
<!--            {{ statistics.applicationMaterials.confirmed }}-->
<!--          </el-descriptions-item>-->

          <el-descriptions-item label="待上传">
            {{ statistics.applicationMaterials.needuploaded }}
          </el-descriptions-item>
          <el-descriptions-item
            :labelStyle="
              statistics.applicationMaterials.unmodified > 0 ? 'color:red' : ''
            "
            label="待学生修改"
          >
            <div
              v-if="statistics.applicationMaterials.unmodified > 0"
              class="uncomplete"
            >
              {{ statistics.applicationMaterials.unmodified }}
            </div>
            <div v-else>
              {{ statistics.applicationMaterials.unmodified }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="已上传">
            {{ statistics.applicationMaterials.unconfirmed }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </hb_info_section_template>

    <hb_info_section_template title="选校" @headerClick="changeTab('second')">
      <template slot="content">
        <el-link
          @click="changeTab('second')"
          type="danger"
          v-if="
            !statistics.schoolChoice
          "
          >未选校</el-link
        >
        <el-descriptions v-else :column="4">
          <!-- <el-descriptions-item label="已申请">{{
            statistics.schoolChoice.applied
          }}</el-descriptions-item>
          <el-descriptions-item label="已确认(待申请)">{{
            statistics.schoolChoice.confirmed
          }}</el-descriptions-item> -->
          <el-descriptions-item label="申请中">{{
              statistics.schoolChoice.applying
            }}</el-descriptions-item>
          <el-descriptions-item label="申请结束">{{
              statistics.schoolChoice.applied
            }}</el-descriptions-item>


          <el-descriptions-item
            :labelStyle="
              statistics.schoolChoice.unconfirmed > 0 ? 'color:red' : ''
            "
            label="待学生确认"
          >
            <div
              style="color: red"
              v-if="statistics.schoolChoice.unconfirmed > 0"
            >
              {{ statistics.schoolChoice.unconfirmed }}
            </div>
            <div v-else>{{ statistics.schoolChoice.unconfirmed }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="待老师修改">
            {{ statistics.schoolChoice.unmodified }}
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </hb_info_section_template>




    <hb_info_section_template
      title="CV"
      @headerClick="changeTab('eleven')"
    >
      <template slot="content">
        <div @click="changeTab('eleven')">

          <span class="desc-txt" v-if="statistics.userInformationData.cv_status == 4"
          >已完成必填项</span
          >
          <span class="uncomplete" v-else-if="statistics.userInformationData.cv_status == 5"
          >未完成必填项</span>
          <span class="uncomplete" v-else
            >未填写</span
          >
        </div>
      </template>
    </hb_info_section_template>



    <hb_info_section_template
      title="PS"
      tip="'未填写'和'初稿编辑中'为学生需要完成；'初稿'为老师需要完成"
      @headerClick="changeTab('six')"
    >
      <template slot="content">
        <div @click="changeTab('six')">
          <span class="desc-txt" v-if="statistics.referrer.status == 4"
          >已完成必填项</span
          >
          <span class="uncomplete" v-else-if="statistics.referrer.status == 5"
          >未完成必填项</span>
          <span class="uncomplete" v-else
            >未填写</span
          >
        </div>
      </template>
    </hb_info_section_template>

    <hb_info_section_template
      title="RL"
      tip="'未填写'和'初稿编辑中'为学生需要完成；'初稿'为老师需要完成"
      @headerClick="changeTab('seven')"
    >
      <template slot="content">
        <div @click="changeTab('seven')">
          <span class="desc-txt" v-if="statistics.rl.status == 4"
          >已完成必填项</span
          >
          <span class="uncomplete" v-else-if="statistics.rl.status == 5"
          >未完成必填项</span>
          <span class="uncomplete" v-else
            >未填写</span
          >
        </div>
      </template>
    </hb_info_section_template>

    <hb_info_section_template title="文书" @headerClick="changeTab('five')">
      <template slot="content">
        <el-descriptions :column="2">
          <el-descriptions-item label="CV">
            <span style="margin-right: 10px"
              >已确认{{ statistics.document.cv.confirmed }}</span
            >
            <span
              :class="
                statistics.document.cv.unconfirmed > 0
                  ? 'uncomplete'
                  : 'desc-txt'
              "
              style="margin-right: 10px"
              >待学生确认{{ statistics.document.cv.unconfirmed }}</span
            >
            <span style="margin-right: 10px"
              >待老师修改{{ statistics.document.cv.unmodified }}</span
            >
            <span style="margin-right: 10px"
              >待老师上传{{ statistics.document.cv.needuploaded }}</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="RL">
            <span style="margin-right: 10px"
              >已确认{{ statistics.document.rl.confirmed }}</span
            >
            <span
              :class="
                statistics.document.rl.unconfirmed > 0
                  ? 'uncomplete'
                  : 'desc-txt'
              "
              style="margin-right: 10px"
              >待学生确认{{ statistics.document.rl.unconfirmed }}</span
            >
            <span style="margin-right: 10px"
              >待老师修改{{ statistics.document.rl.unmodified }}</span
            >
            <span style="margin-right: 10px"
              >待老师上传{{ statistics.document.rl.needuploaded }}</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="PS">
            <span style="margin-right: 10px"
              >已确认{{ statistics.document.ps.confirmed }}</span
            >
            <span
              :class="
                statistics.document.ps.unconfirmed > 0
                  ? 'uncomplete'
                  : 'desc-txt'
              "
              style="margin-right: 10px"
              >待学生确认{{ statistics.document.ps.unconfirmed }}</span
            >
            <span style="margin-right: 10px"
              >待老师修改{{ statistics.document.ps.unmodified }}</span
            >
            <span style="margin-right: 10px"
              >待老师上传{{ statistics.document.ps.needuploaded }}</span
            >
          </el-descriptions-item>
        </el-descriptions>
      </template>
    </hb_info_section_template>

    <!-- 邮箱绑定弹框 -->
    <el-dialog :visible.sync="openDialog" width="50%" center title="绑定邮箱">
      <div>
        <el-form ref="form" label-width="80px">
          <el-form-item label="邮箱" required>
            <el-input
              placeholder="请输入共享邮箱"
              v-model="emailCon.email"
              style="width: 60%"
            >
              <el-select
                v-model="emailCon.email_value"
                placeholder="请选择"
                slot="append"
                style="width: 130px"
              >
                <el-option
                  v-for="(item, index) in email_list"
                  :key="index"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="邮箱密码" required>
            <el-input
              show-password
              v-model="emailCon.pass"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" required>
            <el-input
              show-password
              v-model="emailCon.check_pass"
              placeholder="请再次输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" required>
            <el-input
              placeholder="请输入邮箱验证码"
              v-model="emailCon.email_code"
              style="width: 60%"
            ></el-input>
            <el-button
              style="margin: 0 20px; width: 20%"
              @click.stop="sendVerificationCode"
              type="primary"
              v-if="show"
              :loading="codeLoading"
              >发送验证码</el-button
            >
            <el-button
              style="margin: 0 20px; width: 20%"
              type="primary"
              v-if="!show"
              disabled
              >{{ count }}秒后重发</el-button
            >
            <!-- <div class="brief_introduction">
              推荐邮箱名格式：姓名拼音_出生年月日@163.com
              如：zhangsan_20200608@163.com
            </div> -->
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="lookScores">保存</el-button>
      </span>
    </el-dialog>

    <!-- 邮箱详情弹框 -->
    <el-dialog :visible.sync="showDialog" width="50%" center title="共享邮箱">
      <div>
        <el-form ref="form">
          <el-form-item label="邮箱：">{{ user_bind_info.email }}</el-form-item>
          <el-form-item label="邮箱密码：">{{
            user_bind_info.email_pass
          }}</el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">返 回</el-button>
        <el-button type="primary"  @click="confirmBindEmail">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  email_bind,
  email_code,
  get_study_abroad_information_statistics,
} from "@/api/mycenter_studyabroad";
import hb_info_section_template from "./abroad_info_section.vue";
export default {
  name: "TabFirst",
  props: ["flag"],
  components: {
    hb_info_section_template,
  },
  data() {
    return {
      codeLoading: false,
      show: true,
      count: "",
      timer: null,
      email_list: ["@163.com"],
      user_bind_info: [],
      emailCon: {
        check_pass: "",
        email: "",
        pass: "",
        email_value: "@163.com",
        email_code: "",
      },
      statistics: null,
      openDialog: false,
      showDialog: false,
    };
  },
  created() {
    this.$bus.on("abroad_tabs_changes", (newVal) => {
      if (newVal == this.flag) {
        this.requestAll();
      }
    });
    this.requestAll();
  },
  methods: {
    confirmBindEmail() {
      this.emailCon.email = ''
      this.emailCon.check_pass = ''
      this.emailCon.pass = ''
      this.emailCon.email_code = ''
      this.showDialog = false
      this.openDialog = true
    },
    requestAll() {
      this.getStudyAbroadInformationStatistics();
      this.getUserBindInfo();
    },
    // 去填写个人信息
    changeTab(val) {
      this.$bus.emit("change-abroad-tab", val);
    },
    getStudyAbroadInformationStatistics() {
      get_study_abroad_information_statistics({}).then((response) => {
        this.statistics = response.data;
      });
    },
    sendVerificationCode() {
      if (!this.emailCon.email) {
        this.$message({
          message: "邮箱不能为空",
          type: "error",
        });
        return;
      }
      this.email_code();
    },
    lookScores() {
      if (!this.emailCon.email) {
        this.$message({
          message: "邮箱不能为空",
          type: "error",
        });
        return;
      }
      if (!this.emailCon.email_code) {
        this.$message({
          message: "验证码不能为空",
          type: "error",
        });
        return;
      }
      if (!this.emailCon.pass) {
        this.$message({
          message: "密码输入不能为空",
          type: "error",
        });
        return;
      }
      if (this.emailCon.pass !== this.emailCon.check_pass) {
        this.$message({
          message: "两次密码输入不一致",
          type: "error",
        });
        return;
      }
      email_bind({ email: this.emailCon, user_id: this.urserid }).then(
        (response) => {
          this.openDialog = false;
          this.getUserBindInfo();
        }
      );
    },
    email_code() {
      this.codeLoading = true;
      var email = this.emailCon.email + this.emailCon.email_value;
      email_code({ email: email })
        .then((response) => {
          this.startCountDown();
          this.codeLoading = false;
          this.$message.success(
            `验证码已发送至：${this.emailCon.email}，请前往查收`
          );
        })
        .catch((error) => {
          this.$message.error(error.message);
          this.codeLoading = false;
        });
    },
    startCountDown() {
      var TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    bindEmail() {
      this.openDialog = true;
    },
    showEmail() {
      this.showDialog = true;
    },
    getUserBindInfo() {
      this.$store
        .dispatch(
          "userAbroad/geUserAbroadData",
          parseInt(this.$route.query.userId)
        )
        .then(() => {
          this.user_bind_info = this.$store.state.userAbroad.userAbroadData;
        });
    },
  },
  computed: {
    pageLoading: {
      get() {
        if (this.$store.state.userAbroad.userAbroadDataState == "loading") {
          return true;
        } else {
          return false;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.hb-abroad-index-page {

  .section-title {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }
  .desc-txt {
    font-size: 14px;
    color: #606266;
    font-weight: 400
  }
  .uncomplete {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_first.vue